<div class="engi-product-poses" *ngIf="poses">
  <p class="engi-product-poses__title">{{"product.availability.stationary" | translate}}</p>
  <div class="engi-product-poses__select">
    <ng-select (change)="onChangeCity($event)" [items]="storesCities" [placeholder]="'product.availability.select.placeholder' | translate" [notFoundText]="'ng-select.notFoundText' | translate" class="engi-product-poses__select__box"></ng-select>
  </div>
  <ul *ngIf="selectedCity" class="engi-product-poses__list" [ngClass]="{'engi-fade': showList}">
    <li *ngFor="let pos of poses | cityfilter: selectedCity" class="engi-product-poses__item">
      <span class="engi-product-poses__item__storeName">{{pos.pointOfService.storeName}}</span>
      <div class="engi-product-poses__item__availability" [ngClass]="{'engi-high': pos.availability > 2, 'engi-low': pos.availability <= 2 && pos.availability > 0}">
        <span *ngIf="asmMode === 'true'; then availabilityForAsm else availabilityForOnline"></span>
      </div>
      <ng-template #availabilityForAsm>
        {{pos.availability > 0 ? pos.availability : pos.availability === 0 ? ('product.availability.unavailable' | translate) : ('product.availability.outofstock' | translate)}}
      </ng-template>
      <ng-template #availabilityForOnline>
        {{pos.availability > 0 ?
          (pos.availability > 2 ? ("product.availability.high" | translate) : ("product.availability.low" | translate)) :
          ("product.availability.unavailable" | translate) }}
      </ng-template>
      <div class="engi-product-poses__item__address">{{pos.pointOfService.streetName}}</div>
      <div class="engi-product-poses__item__address">{{pos.pointOfService.postCode}} {{pos.pointOfService.city}}</div>
    </li>
  </ul>
  <div class="engi-product-poses__item engi-product-poses__item--online" *ngIf="onlineStore">
    <p class="engi-product-poses__title">{{onlineStore.pointOfService.storeName}}</p>
    <div class="engi-product-poses__item__availability" [ngClass]="{'engi-high': onlineStore.availability > 2, 'engi-low': onlineStore.availability <= 2 && onlineStore.availability > 0}" >
      <span *ngIf="asmMode === 'true'; then onlineAvailabilityForAsm else onlineAvailabilityForOnline"></span>
    </div>
    <ng-template #onlineAvailabilityForAsm>
      {{onlineStore.availability > 0 ? onlineStore.availability : onlineStore.availability === 0 ? ('product.availability.unavailable' | translate) : ('product.availability.outofstock' | translate)}}
    </ng-template>
    <ng-template #onlineAvailabilityForOnline>
      {{onlineStore.availability > 0 ? (onlineStore.availability > 2 ? ("product.availability.high" | translate) : ("product.availability.low" | translate)) : ("product.availability.unavailable" | translate) }}
    </ng-template>
  </div>

</div>
